import { menuItem, MenuResponseJSON } from "../helpers/interfaces";

export type NavbarItem = {
  id: string,
  name: string,
  path: string,
  subRoutes?: Array<NavbarItem>,
  headerNavbar?: boolean,
  footerNavbar1?: boolean,
  footerNavbar2?: boolean,
  footerNavbarOrder?: number,
}

export async function getNavbar(
  data: MenuResponseJSON
): Promise<NavbarItem[]> {
  const createSubRoutes = (subItems: menuItem[]): NavbarItem[] => {
    return subItems.map((item: menuItem) => {
      const subRoute: NavbarItem = {
        id: item.type,
        name: item.label,
        path: item.url ? `/${item.url}` : "",
        headerNavbar: true,
        footerNavbar1: item.footerColumn === 'colonna1',
        footerNavbar2: item.footerColumn === 'colonna2',
        footerNavbarOrder: item.footerOrder !== null
          ? Number(item.footerOrder) : undefined,
        subRoutes: item.sub ? createSubRoutes(item.sub) : [],
      };

      return subRoute;
    });
  };

  const menuItems = data.data.slice(1).map((mainItem: menuItem) => {
    const mainNavbarItem: NavbarItem = {
      id: mainItem.type,
      name: mainItem.label,
      path: mainItem.url ? `/${mainItem.url}` : "",
      headerNavbar: true,
      footerNavbar1: mainItem.footerColumn === 'colonna1',
      footerNavbar2: mainItem.footerColumn === 'colonna2',
      footerNavbarOrder: mainItem.footerOrder !== null
        ? Number(mainItem.footerOrder) : undefined,
      subRoutes: mainItem.sub ? createSubRoutes(mainItem.sub) : [],
    };

    return mainNavbarItem;
  });

  const mainSubRoutes = data.data[0]?.sub ? createSubRoutes(data.data[0].sub) : [];

  return [...menuItems, ...mainSubRoutes];
}
